import { MedicineSimple } from '@dreryk/drerykweb-medicine-api';

import {
   createFrequencyDosageCycle,
   ExtendedDosage,
   getDefaultDosageUnit,
   normalizeStageForForm,
   normalizeStageForSave,
} from '~libs.shared.prescription';

import { ExtendedDosageFormBean } from './form/ExtendedDosageForm.types';

export {
   ADMINISTRATION_INTERVAL_DAYS,
   createDosageBreak,
   createFrequencyDosageCycle,
   createTimesOfDayDosageCycle,
   DOSAGE_DURATION_UNITS,
   DOSAGE_TIME_UNITS,
   DOSAGE_TIMES_OF_DAY,
   duplicateStage,
   getAdministrationIntervalDays,
   getStageWithTimesOfDay,
} from '~libs.shared.prescription';
export type { AdministrationIntervalDays, DosageCycleClass } from '~libs.shared.prescription';

export const getExtendedDosagePortionUnit = (
   extendedDosage: ExtendedDosage | null,
   medicine: MedicineSimple
): string | null => extendedDosage?.portionUnit ?? getDefaultDosageUnit(medicine) ?? null;

export const mapExtendedDosageToFormBean = (
   extendedDosage: ExtendedDosage | null,
   portionUnit: string | null,
   dosage: string | null
): ExtendedDosageFormBean => {
   const stages = (extendedDosage?.stages ?? []).map(normalizeStageForForm);

   return {
      stages: stages.length > 0 ? stages : [createFrequencyDosageCycle()],
      portionUnit: portionUnit,
      patientInstruction: dosage,
      templateName: null,
   };
};

export const createExtendedDosageFormBeanInitializer = (
   extendedDosage: ExtendedDosage | null,
   portionUnit: string | null,
   dosage: string | null
) => (): ExtendedDosageFormBean => mapExtendedDosageToFormBean(extendedDosage, portionUnit, dosage);

export const mapFormBeanToExtendedDosage = (bean: ExtendedDosageFormBean): ExtendedDosage => ({
   stages: (bean.stages ?? []).map(normalizeStageForSave),
   portionUnit: bean.portionUnit ?? undefined,
});
